import React from 'react';
import { Label } from '@gjensidige/core-typography';
import utils from '@gjensidige/core-utilities-css';
import { text } from '../../../utils/text';
import { Clipboard } from '@gjensidige/core-clipboard';
import { accountNumberFormatted } from '@gjensidige/gpf-js-utils/es6/text/formatting';
import { Spacer } from '../Spacer/Spacer';
import styles from './KidAccountCopy.module.less';
export const KidAccountCopy = ({ kid, accountNumber }) => {
    return (React.createElement(Spacer, { child: 'sm', className: styles.clipboard },
        kid && (React.createElement(React.Fragment, null,
            React.createElement(Label, { className: utils['font-weight-bold'] }, text.START_SAVING_PAGE.KID_NUMBER.no),
            React.createElement(Clipboard, { copyText: text.COMMON.COPY.no, copiedText: text.COMMON.COPIED.no, clipboardText: kid }))),
        accountNumber && (React.createElement(React.Fragment, null,
            React.createElement(Label, { className: utils['font-weight-bold'] }, text.START_SAVING_PAGE.ACCOUNT_NUMBER.no),
            React.createElement(Clipboard, { copyText: text.COMMON.COPY.no, copiedText: text.COMMON.COPIED.no, clipboardText: accountNumberFormatted(accountNumber) })))));
};
